import React, { useState, useEffect } from 'react';
import { useConditional } from '../../state/storeConditional ';

type Props = {}

const RamadanActivate = (props: Props) => {
  const { updateIsRamadan, isRamadan, updateIsOnChangeInHijra } = useConditional();
  const [isChecked, setIsChecked] = useState(isRamadan.ramadan);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    setIsChecked(isRamadan.ramadan);
  }, [isRamadan.ramadan]);

  const handlerCheck = (checkedValue: boolean, customValue?: number) => {
    const finalValue = customValue !== undefined ? customValue : isRamadan.ramadan_custom;

    const newData = {
      ramadan: checkedValue,
      zuhrEnd: "Zuhr End",
      iftarStart: "Iftar Start",
      ramadan_custom: finalValue
    };
    
    updateIsRamadan(newData);
    updateIsOnChangeInHijra(true);
  }

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    handlerCheck(isChecked, newValue);
  }

  const incrementValue = () => {
    const newValue = isRamadan.ramadan_custom === -1 ? 0 : isRamadan.ramadan_custom + 1;
    handlerCheck(isChecked, newValue);
  }

  const decrementValue = () => {
    const newValue = isRamadan.ramadan_custom === 1 ? 0 : isRamadan.ramadan_custom - 1;
    handlerCheck(isChecked, newValue);
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checkedValue = e.target.checked;
    setIsChecked(checkedValue);
    handlerCheck(checkedValue);
    setIsHidden(!checkedValue);
  }

  return (
    <fieldset className='m-2'>
      <div className='m-2'>
        <label htmlFor="ramadan" className='text-lg'>Activate Ramadan</label>
         
        <p className={!isHidden ? 'hidden' : 'block'}>If you’ve deactivated the Ramadan setting and can’t see the calendar, don’t worry! Just go back to your prayer settings. Look for the option that lets you change the month, and switch it to the current date, Please Save it.</p>
        
        <input 
          className='m-2' 
          type="checkbox" 
          id="ramadan" 
          name="ramadan" 
          value="ramadan" 
          onChange={handleCheckboxChange}
          checked={isChecked} // Always controlled
        />
      </div>
      
      { isRamadan.ramadan &&
        <div className='m-2'>
          <legend className='text-lg'>Adjust Starting of Ramadan:</legend>
          <p>When you activate Ramadan, go back to Prayer settings, select Ramadan in the Month Options Selection, and then come back here to see the changes you made. Save it.</p>
          <div className='flex justify-center items-center gap-x-4 mt-3'> {/* Centered container with spacing */}
            <button 
              type="button" 
              onClick={decrementValue} 
              className='px-3  bg-red-500 text-white rounded text-lg' // Shorter button
            >
              -
            </button>
            <input 
              type="number" 
              id="ramadan_custom" 
              name="ramadan_custom" 
              value={isRamadan.ramadan_custom} 
              onChange={handleValueChange}
              className='w-16  text-center border rounded text-lg' // Input in the middle
            />
            <button 
              type="button" 
              onClick={incrementValue} 
              className='px-3  bg-green-500 text-white rounded text-lg' // Shorter button
            >
              +
            </button>
          </div>
        </div>
      }
    </fieldset>
  );
}

export default RamadanActivate;